/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
import React, { memo, useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import ClickableDiv from 'components/Common/ClickableDiv';
import AddIcon from '@material-ui/icons/Add';
import API from 'api';
import Ad from 'models/business/Ad';
import Market from 'models/business/Market';
import Asset from 'models/business/Asset';
import HeaderTypography from '../../Common/HeaderTypography';
import TopUpCard from '../../Common/TopUpCard';
import HintDashboard from './HintDashBoard';
import MarketDashboard from './MarketDashboard';
import AdDashboard from './AdDashboard';
import Styles from './index.module.css';

function MyAds() {
  const [markets, setMarkets] = useState([]);
  const [ads, setAds] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [amounts, setAmounts] = useState(JSON.parse(localStorage.getItem('amounts')));
  const history = useHistory();
  const [activeFilter, setActiveFilter] = useState('Undone');
  const [sumCostGoogleEffect, setSumCostGoogleEffect] = useState(0);
  const [sumCostFacebookEffect, setSumCostFacebookEffect] = useState(0);
  const fetchMarketAssets = async (id) => {
    const result = await API.mall.getMallAssets(id);
    if (result.error) {
      alert(result.error.errorMsg);
      return null;
    }

    return (result.resultData || []).map((a) => new Asset(a))[0];
  };

  const fetchMarkets = async () => {
    const result = await API.mall.getMallList();
    if (result.error) {
      alert(result.error.errorMsg);
      return [[], result.error];
    }
    // eslint-disable-next-line max-len
    return [(result.resultData || []).map((ad) => new Market(ad))];
  };

  const fetchAds = async () => {
    // const result = await API.ad.postAdList();
    const result = await API.ad.postAdList2();
    if (result.error) {
      alert(result.error.errorMsg);
      return [[], result.error];
    }
    return [(result.resultData || []).map((ad) => new Ad(ad))];
  };

  const load = async () => {
    const [newMarkets, marketError] = await fetchMarkets();
    const marketLookup = newMarkets.reduce((ms, m) => ({ ...ms, [m.id]: m }), {});
    const [newAds, adError] = await fetchAds();
    const marketAssetLookup = [];
    for (let i = 0; i < newMarkets.length; i += 1) {
      // eslint-disable-next-line no-await-in-loop
      const asset = await fetchMarketAssets(newMarkets[i].id);
      if (asset) marketAssetLookup[newMarkets[i].id] = asset;
    }
    newAds.forEach((ad) => {
      ad.injectMarket(marketLookup[ad.marketId]);
      // eslint-disable-next-line no-param-reassign
      ad.marketContentFeedId = marketAssetLookup[ad.marketId]?.id || '';
    });
    setMarkets(newMarkets);
    setAds(newAds);
    return {
      markets: newMarkets,
      ads: newAds,
      error: marketError || adError,
    };
  };

  const onChangeAds = async (newAd) => {
    switch (newAd.status) {
      case 'Undone':
      case 'Archive':
        setActiveFilter('Undone');
        break;
      case 'Online':
      case 'Pending':
        setActiveFilter('Online');
        break;
      case 'Stopped':
        setActiveFilter('Stopped');
        break;
      default:
        setActiveFilter('Undone');
        break;
    }
    // alert('onChangeAds');
    // const index = ads.findIndex((obj) => obj.id === newAd.id);
    // if (index > -1) {
    //   // adsTmp[index] = newAd;
    //   ads.splice(index);
    // }
    // setAds(ads);
    load();
    // const newAds = [(ads || []).map((ad) => new Ad(ad))];
    // const index = ads.findIndex((obj) => obj.id === newAd.id);
    // if (index > -1) {
    //   ads[index] = new Ad(newAd);
    // }
    // setAds(ads);
    // window.location.reload(false);
    window.scrollTo(0, 0);
  };

  useEffect(async () => {
    const userInfo = await API.auth.getUserInfo();
    if (!userInfo.error) {
      localStorage.setItem('amounts', JSON.stringify({ google: userInfo.resultData.googleAmount, facebook: userInfo.resultData.facebookAmount }));
    }
    const resultGoogleEffect = await API.ad.getGooglePerformanceData((new Date('October 1, 2021 08:00:00')).toISOString(), (new Date()).toISOString());
    setSumCostGoogleEffect(resultGoogleEffect.resultData.reduce((accumulator, item) => accumulator + +item.cost, 0));
    const resultFacebookEffect = await API.ad.getFacebookPerformanceData((new Date('October 1, 2021 08:00:00')).toISOString(), (new Date()).toISOString());
    setSumCostFacebookEffect(resultFacebookEffect.resultData.reduce((accumulator, item) => accumulator + +item.cost, 0));
    load().then(({ markets: newMarkets, error }) => {
      if (!error && !newMarkets.length) {
        alert('請新增賣場再繼續');
        history.push('/MarketSetting');
      }
    });
  }, []);

  return (
    <div className={Styles.myAdsWrapper}>
      <div className={Styles.myAdsLeftSide}>
        <HintDashboard />
      </div>
      <div className={Styles.myAdsBody}>
        <div className={Styles.title}>
          <HeaderTypography>
            儲值狀態
          </HeaderTypography>
        </div>
        <div className={Styles.dashboard}>
          <TopUpCard
            ads={ads}
            sumCostGoogleEffect={sumCostGoogleEffect}
            sumCostFacebookEffect={sumCostFacebookEffect}
          />
        </div>
        <div className={Styles.title} style={{ marginBottom: '8px' }}>
          <div>
            <HeaderTypography>
              廣告總覽
            </HeaderTypography>
          </div>
          {/* <ClickableDiv
            className={Styles.addAD}
            onClick={() => history.push('/SelectOptionStep')}
          >
            <div>
              <AddIcon className={Styles.addIcon} />
            </div>
          </ClickableDiv> */}
        </div>
        <div className={Styles.addAdCardItem}>
          <ClickableDiv
            className={Styles.addAdContainer}
            onClick={() => history.push('/SelectOptionStep')}
          >
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignContent: 'center',
              }}
            >
              <AddIcon style={{ color: '#455780' }} />
            </div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignContent: 'center',
              }}
            >
              <HeaderTypography>
                新增廣告
              </HeaderTypography>
            </div>
          </ClickableDiv>
        </div>
        <div className={Styles.dashboard}>
          <AdDashboard
            ads={ads}
            amounts={amounts}
            activeFilter={activeFilter}
            onChangeAds={onChangeAds}
          />
        </div>
      </div>
      <div className={Styles.myAdsSide}>
        <MarketDashboard onChangeMarkets={load} markets={markets} />
      </div>
    </div>
  );
}

export default memo(MyAds);
